import api from './';

export default {
  fetchAll: () => api.get('access_tokens').json().then(response => response.data),
  enable: (id) => api.post(`access_tokens/${id}/enable`).json(),
  disable: (id) => api.post(`access_tokens/${id}/disable`).json(),
};
